import { Category } from '@common/types/categories/category';

export const filterSupportedPlatforms = (platforms: Category[]) => {
  return platforms.filter(
    (val) =>
      val.name.includes('Apple Music') ||
      val.name.includes('Deezer') ||
      val.name.includes('Facebook') ||
      val.name.includes('Shazam') ||
      val.name.includes('SoundCloud') ||
      val.name.includes('Spotify') ||
      val.name.includes('TikTok') ||
      val.name.includes('United Media Agency')
  );
};
